import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { FiCheckCircle, FiAward } from 'react-icons/fi';

const GoalAchievementPopup = ({ isOpen, onClose, milestone }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (isOpen) {
            setProgress(0);
            const timer = setTimeout(() => {
                setProgress(100);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    if (!isOpen || !milestone) return null;

    const title = milestone.title || "Poziom Osiągnięty";
    const description = milestone.description || "Świetna robota, kolejny krok za Tobą.";

    return ReactDOM.createPortal(
        <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4">
            {/* TŁO */}
            <div 
                className="absolute inset-0 bg-[#233855]/60 backdrop-blur-sm animate-in fade-in duration-300"
                onClick={onClose}
            ></div>

            {/* KARTA */}
            <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-[0_15px_35px_-5px_rgba(35,56,85,0.3)] overflow-hidden animate-in zoom-in-95 duration-300 border border-[#E09F2E]/40">
                
                {/* HEADER */}
                <div className="bg-[#233855]/5 px-5 py-3 border-b border-[#233855]/5 flex items-center justify-between">
                     <div className="flex items-center gap-2.5">
                        <div className="flex items-center justify-center w-7 h-7 rounded-full bg-white text-[#E09F2E] shadow-sm border border-[#E09F2E]/20">
                            <FiAward className="text-sm" />
                        </div>
                        <div className="flex flex-col">
                            <span className="text-[10px] font-bold tracking-widest text-[#233855] uppercase leading-tight">
                                Poziom Ukończony
                            </span>
                        
                        </div>
                     </div>
                </div>

                {/* CONTENT */}
                <div className="p-6">
                    
                    {/* INFO */}
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mb-1">
                             <div className="w-1.5 h-1.5 rounded-full bg-[#E09F2E] animate-pulse"></div>
                             <p className="text-[10px] uppercase tracking-widest text-gray-400 font-bold">
                                Ukończono poziom
                             </p>
                        </div>
                        <h3 className="text-3xl font-bold font-apotek text-[#233855] leading-none uppercase mb-2">
                            {title}
                        </h3>
                        <p className="text-sm text-gray-500 font-medium leading-relaxed">
                            {description}
                        </p>
                    </div>

                    {/* PASEK POSTĘPU */}
                    <div className="mb-8">
                        <div className="flex justify-between text-xs font-semibold mb-1.5 tracking-wide">
                            <span className="text-[#E09F2E] font-bold flex items-center gap-1.5">
                                <FiCheckCircle /> Cel Zrealizowany
                            </span>
                            <span className="text-[#233855] font-bold">100%</span>
                        </div>
                        
                        <div className="w-full h-3.5 bg-gray-100 rounded-full overflow-hidden border border-gray-200">
                            <div 
                                className="h-full rounded-full shadow-[0_0_10px_rgba(248,171,59,0.3)] bg-gradient-to-r from-[#F8AB3B] to-[#FFD700] relative transition-all duration-[1000ms] ease-out"
                                style={{ width: `${progress}%` }}
                            >
                                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/40 to-transparent opacity-50"></div>
                            </div>
                        </div>
                    </div>

                    {/* PRZYCISK "SUPER" Z EFEKTEM KOMETY */}
                    <div className="relative group rounded-xl overflow-hidden p-[2px]">
                        {/* Animowana Kometa */}
                        <div 
                          className="absolute inset-[-1000%] animate-[spin_4s_linear_infinite] bg-[conic-gradient(from_0deg_at_50%_50%,transparent_0%,transparent_50%,#E09F2E_100%)]" 
                        />
                        
                        {/* Właściwy Przycisk */}
                        <button
                            onClick={onClose}
                            className="relative w-full flex justify-center items-center gap-2 rounded-[10px] bg-[#233855] px-6 py-4 text-lg font-apotek tracking-widest text-slate-100 hover:bg-[#2a4263] hover:text-white transition-all duration-200 cursor-pointer z-10 uppercase shadow-lg"
                        >
                            SUPER
                        </button>
                    </div>

                </div>
            </div>
        </div>,
        document.body
    );
};

export default GoalAchievementPopup;